import { Translation } from "primeng/api";

/**
 * PrimeNG ships no locale bundles, so we provide the date strings and the
 * shared component messages (empty states, etc.) ourselves and feed them to
 * the global PrimeNG config (`PrimeNG.setTranslation`). Anything not listed
 * here falls back to PrimeNG's built-in English defaults. Day arrays are
 * Sunday-first (PrimeNG rotates them using `firstDayOfWeek`).
 *
 * `firstDayOfWeek` is Monday (1) for both languages: this is a Morocco-based
 * medical scheduling app where weekends are disabled, so a Monday-first grid is
 * the clearest and most consistent choice across languages.
 */
export const PRIMENG_FR: Translation = {
  firstDayOfWeek: 1,
  dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
  dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
  monthNames: [
    "janvier", "février", "mars", "avril", "mai", "juin",
    "juillet", "août", "septembre", "octobre", "novembre", "décembre",
  ],
  monthNamesShort: [
    "janv.", "févr.", "mars", "avr.", "mai", "juin",
    "juil.", "août", "sept.", "oct.", "nov.", "déc.",
  ],
  today: "Aujourd'hui",
  clear: "Effacer",
  dateFormat: "dd/mm/yy",
  weekHeader: "Sem.",
  emptyMessage: "Aucun résultat trouvé",
  emptyFilterMessage: "Aucun résultat trouvé",
  emptySearchMessage: "Aucun résultat trouvé",
};

export const PRIMENG_EN: Translation = {
  firstDayOfWeek: 1,
  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  monthNames: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ],
  monthNamesShort: [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ],
  today: "Today",
  clear: "Clear",
  dateFormat: "dd/mm/yy",
  weekHeader: "Wk",
  emptyMessage: "No results found",
  emptyFilterMessage: "No results found",
  emptySearchMessage: "No results found",
};

/** Returns the PrimeNG date translation for an app language code ("fr" / "en"). */
export function getPrimeNgDateLocale(lang: string | null | undefined): Translation {
  return lang?.toLowerCase().startsWith("en") ? PRIMENG_EN : PRIMENG_FR;
}
